import baseRoute from '../baseRoute';

export type * from './viewModel';

type RouteDefinition = `${typeof baseRoute}/purchaseOrderOptions`;

export const ROUTE: RouteDefinition = `${baseRoute}/purchaseOrderOptions`;

export const URL = (): RouteDefinition => `${baseRoute}/purchaseOrderOptions`;
